import clsx from "clsx";
import { ValueContainerProps } from "react-select";
import { SelectOption } from "./types";

export function ValueContainer({
  children,
  isMulti,
  selectProps: { classes },
}: ValueContainerProps<SelectOption>) {
  return (
    <div
      className={clsx({
        [classes.valueContainerMulti]: isMulti,
        [classes.valueContainerSingle]: !isMulti,
      })}
    >
      <div
        className={clsx({
          [classes.valueContainerMultiItems]: isMulti,
          [classes.valueContainerSingleItem]: !isMulti,
        })}
      >
        {children}
      </div>
    </div>
  );
}
